import React, { Component } from 'react'
import Container from '../common/application_container'
import Tabs from 'react-responsive-tabs';
import { TabComponents } from './tabsItem'
import { Link, withRouter } from 'react-router-dom'
// IMPORTANT you need to include the default styles
import 'react-responsive-tabs/styles.css';
import AccountActivity from './components/accountActivity';
import ServerConfig from './components/serverConfig';
import Billing from './components/billing';
import Debit_Credit from './components/debit-credit';
import CallLogs from './components/callLogs';
import CarrierRestriction from './components/carrierRestriction';
import AgentTable from './components/agentSection/agentTable';
import { AccountTable } from '../Accounts/accountTable';
import { AccountInformation } from '../Accounts/accountInformation';
import ProductIndex from './components/product';
import StirShakenSubjectBlock from './components/stirShakenSubjectBlock.js';
import AccountCallRestriction from '../Accounts/accountCallRestriction.js';



export class AdditionalAccountInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id,
            name: this.props.match.params.accountName,
            typee:this.props.match.params.type
        }
    }

    getTabs() {
        const tabItemList = [
            {
                name: 'Account Information',
                biography: <AccountInformation  userId={this.state.id} accountName={this.state.name} />
            },
            {
                name: 'Pricing',
                biography: <Billing checkType={this.state.typee} userId={this.state.id} accountName={this.state.name} />
            },
            {
                name: 'Product Billing',
                biography: <ProductIndex checkType={this.state.typee} userId={this.state.id} accountName={this.state.name} />
            },
            {

                name: 'Account Activity',
                biography: <AccountActivity userId={this.state.id} accountName={this.state.name} />
            },
            {
                name: 'Server Config',
                biography: <ServerConfig userId={this.state.id} accountName={this.state.name} />,
            },
            {
                name: 'Call Logs',
                biography: <CallLogs userId={this.state.id} accountName={this.state.name} />
            },
            {
                name: 'Carrier Restriction',
                biography: <CarrierRestriction userId={this.state.id} />
            },
            {
                name: 'Agent Section',
                biography: <AgentTable userId={this.state.id} />
            },
            {
                name: 'Debit & Credit',
                biography: <Debit_Credit userId={this.state.id} accountName={this.state.name} />
            },
            {
                name: 'Stir Shaken Subject Block',
                biography: <StirShakenSubjectBlock userId={this.state.id} accountName={this.state.name} />
            },
            {
                name: 'Call Restriction',
                biography: <AccountCallRestriction userId={this.state.id} accountName={this.state.name} />
            },
        ]
        return tabItemList.map((president, index) => ({
            title: president.name,
            getContent: () => president.biography,
            /* Optional parameters */
            key: index,
            tabClassName: 'tab',
            panelClassName: 'panel',
        }));
    }

    render() {
        var accountName = this.state.name
        return (
            <Container title={accountName.toUpperCase() + " Account"} title1="Information" icon="icon-clipboard6">
                <Tabs items={this.getTabs()} />
            </Container>
        )
    }
}


export default withRouter(AdditionalAccountInfo)
